// components/common/Pagination.jsx
import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  // Eğer tek sayfa varsa bileşeni hiç göstermeyebiliriz
  if (totalPages <= 1) return null;

  return (
    <div className="p-6 border-t border-slate-50 flex items-center justify-between bg-slate-50/30">
      <span className="text-xs font-black text-slate-400 uppercase tracking-widest">
        Sayfa {currentPage} / {totalPages}
      </span>
      
      <div className="flex gap-2">
        <button 
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
          className="p-2.5 rounded-xl border border-slate-200 bg-white shadow-sm disabled:opacity-30 disabled:cursor-not-allowed hover:bg-slate-50 transition-all active:scale-95"
        >
          <ChevronLeft size={20} className="text-slate-600" />
        </button>
        
        <button 
          disabled={currentPage === totalPages}
          onClick={() => onPageChange(currentPage + 1)}
          className="p-2.5 rounded-xl border border-slate-200 bg-white shadow-sm disabled:opacity-30 disabled:cursor-not-allowed hover:bg-slate-50 transition-all active:scale-95"
        >
          <ChevronRight size={20} className="text-slate-600" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;